/**
 * A widget for display of numeric data and description.
 */
import React, { Component } from 'react';
import { Grid, Paper, Tooltip, Typography} from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import HelpOutline from '@mui/icons-material/HelpOutline';

const styleSheet = theme => ({
  root: {
    width: '100%',
  },
  dbTile: {
    [theme.breakpoints.up('xs')]: {
      padding: theme.spacing(1),
    },
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(1),
    },
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(2),
    },
    height: 68,
    width: 212
  },
  dbTile2: {
    [theme.breakpoints.up('xs')]: {
      padding: theme.spacing(1),
    },
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(1),
    },
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(2),
    },
    height: 68,
    width: 184
  },
});
  
class TextWidget extends Component {
    
  render() {
    const classes = this.props.classes;

    const { narrow, value, description, tooltip } = this.props;

    let theTileClass = classes.dbTile;
    if (narrow === true) {
      theTileClass = classes.dbTile2;
    }

    return (
      <Paper className={theTileClass}>
        <Grid container spacing={1} direction="column" justifyContent="flex-start" alignItems="center">
          <Grid item>
            <Typography variant="h6">{value}</Typography>
          </Grid>
          <Grid item>
            <Grid container justifyContent="flex-start" alignItems="center" spacing={0}>
              <Grid>
                <Typography variant="body2" style={{marginTop: 2}}>{description}</Typography>
              </Grid>
              <Grid item>
                <Tooltip placement='bottom' title={tooltip}>
                  <HelpOutline fontSize="small" style={{verticalAlign: "-9%", marginLeft: '4px'}}/>
                </Tooltip>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    );
  }
}

export default withStyles(styleSheet)(TextWidget);

